/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { MenuItem, Select, TextField, Typography } from "@mui/material";
import { useUpdateComponent } from "cms/components/hooks/use-update-component"
import { useOrgSettings } from "hooks/use-org-settings";
import { useAuth } from "cms/auth/hooks/use-auth.js";
import { Logger } from "cms/utils/log/logger.js";
import { usePartnerCityViz } from "./use-partner-cityviz.js";

const CityVizComponentEditor = () => {

    const { token } = useAuth();
    const { component, update } = useUpdateComponent();
    const { getOrgSettingsString } = useOrgSettings();
    const cityviz_domain = getOrgSettingsString("cityviz_domain");
    const { fetchCityVizWidgets } = usePartnerCityViz();

    const data_domain = component?.data_domain ?? cityviz_domain;
    const widget_type = component?.widget_type ?? "community-profile";
    // const [widgets, setWidgets] = useState([]);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        const executeAsync = async () => {
            try {
                const response = await fetchCityVizWidgets(token);
                // setWidgets(response);
                const opts = [];
                for (const widget of response) {
                    const option = <MenuItem key={widget?.id} value={widget?.id}>{widget?.name}</MenuItem>;
                    opts.push(option);
                }
                setOptions(opts);

            } catch (error) {
                Logger.error("Failed to fetch widgets for cityviz");
            }
        };

        executeAsync();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);
    
    const updateDomain = (event) => {
        const nextValue = event.target.value;
        update("data_domain", nextValue);
    };

    const updateWidgetType = (event) => {
        const nextValue = event.target.value;
        update("widget_type", nextValue);
    };

    return (
        <div className="simplicity-editor-frame" style={{ minHeight: "300px" }} >
            <div style={{ width: "100%" }}>
                <Typography variant='overline' color={"text.secondary"}>
                    Data Domain:
                </Typography>
                <div>
                    <TextField
                        id="data_domain"
                        fullWidth={true}
                        value={data_domain}
                        // placeholder={t("commons.addSubtitle")}
                        onChange={updateDomain}
                    />
                </div>
                <Typography variant="overline" color={"text.secondary"}>
                    Widget Type:
                </Typography>
                <div>
                    {!options &&
                        <Select
                            labelId="widget_type"
                            id='widget_type'
                            variant="outlined"
                            // value={widget_type}
                            // onChange={updateWidgetType}
                            style={{ width: "100%" }}
                        ><MenuItem value="loading">Loading...</MenuItem></Select>
                    }
                    {options &&
                        <Select
                            labelId="widget_type"
                            id='widget_type'
                            variant="outlined"
                            value={widget_type}
                            onChange={updateWidgetType}
                            style={{ width: "100%" }}
                        >
                            {options}
                            {/*<MenuItem value="community-profile">Community Profile</MenuItem>*/}
                            {/*<MenuItem value="transportation">Transportation</MenuItem>*/}
                            {/*<MenuItem value="getting-around">Getting Around</MenuItem>*/}
                            {/*<MenuItem value="explorer">Location Analytics</MenuItem>*/}
                            {/*<MenuItem value="economic-indicators">Economic Indicators</MenuItem>*/}
                            {/*<MenuItem value="industry-profiles">Industry Profiles</MenuItem>*/}
                            {/*<MenuItem value="workforce-profile">Workforce Profile</MenuItem>*/}
                            {/*<MenuItem value="workforce-story">Workforce Trends</MenuItem>*/}
                            {/*<MenuItem value="business-landscape">Business Landscape</MenuItem>*/}
                            {/*<MenuItem value="housing">Housing Profile</MenuItem>*/}
                            {/*<MenuItem value="business-directory">Business Directory</MenuItem>*/}
                            {/*<MenuItem value="tiles">Widget Tiles</MenuItem>*/}
                        </Select>
                    }
                </div>
            </div>
        </div>
    );
};

CityVizComponentEditor.displayName = "CityVizComponentEditor";
export { CityVizComponentEditor };
